import history from '../../util/history'
import { appActions } from '../AppActions'
import taskRepository from '../../infra/TaskRepository'

const onRequestDelete = async taskId => {
  const response = await taskRepository.requestDelete(taskId).catch(e => e)
  if (response instanceof Error) {
    appActions.showAlert(response, '削除に失敗しました')
    return false
  }

  history.goBack()
  appActions.snackbar('削除しました', 'success', true)
  return true
}

export default onRequestDelete
